import React, { Component } from 'react';
import $ from "jquery";
import TopMenu from '../commonFiles/TopMenu';
import Spinner from '../commonFiles/Spinner';
import Footer from '../commonFiles/Footer';
import Banner from './Banner';
import OurTeamInfo from './OurTeamInfo';
class CollaborationsApp extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

componentDidMount(){
  $("html, body").animate({ scrollTop: 0 });
    window.menu_selection('/collaborations');
}


  render() {
    return (
        <div className="container-xxl page_background p-0">
          <Spinner/>
          <TopMenu title="Team"/>
          <OurTeamInfo/>
          <Footer />
        </div>
    );
  }
}

export default CollaborationsApp;
